import React from "react";
export default class SVG extends React.Component {
  render() {
    return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 91" fill="currentColor" {...this.props}><path d="M3.2 0L0 3.3v11.3l7 6.7 7-6.7V0zM3.2 69.1L0 72.4v11.3l7 6.7 7-6.7V69.1zM6 27.4h2v4H6zM6 59.4h2v4H6zM6 51.4h2v4H6zM6 43.4h2v4H6zM6 35.4h2v4H6z" /></svg>;
  }

}


// WEBPACK FOOTER //
// ./src/icons/panel-segment-broken.inline.svg